import { render, staticRenderFns } from "./LogoModalForm.vue?vue&type=template&id=d2c6cf1a"
import script from "./LogoModalForm.vue?vue&type=script&lang=js"
export * from "./LogoModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports